import React from 'react';
import PageMenu from '../../components/PageMenu';

function MenuBuyingGuide(props) {
  return (
    <PageMenu
      {...props}
      title="Buying Guide Menu"
      items={[
        // {
        //   name: 'design-center',
        //   title: 'Design Center',
        // },
        {
          name: 'building-process',
          title: 'Home Building Process',
        },
        {
          name: 'energy-savings',
          title: 'Energy Savings',
        },
        {
          name: 'financing',
          title: 'Financing Your New Home',
        },
        {
          name: 'why-buy-new',
          title: 'Why Buy New',
        },
        {
          name: 'faq',
          title: 'Homebuyer FAQ',
        },
      ]}
    />
  );
}

export default MenuBuyingGuide;



// WEBPACK FOOTER //
// ./src/components/MenuBuyingGuide/index.js